import { IDmNganhActionTypes } from "../../action-types/category/IDmNganhActions";
import { IDmNganhReducer } from "../../reducer-model/category/IDmNganhReducer";
import { eReducerStatusBase } from "../../reducer-model/eReducerStatusBase";
const iniState: IDmNganhReducer = {
  status: eReducerStatusBase.is_not_initialization,
  nganhs: [],
};
export const nganhReducer = (
  state: IDmNganhReducer = iniState,
  action: IDmNganhActionTypes
): IDmNganhReducer => {
  switch (action.type) {
    case "NGANH_LOAD_START":
      return {
        ...state,
        status: eReducerStatusBase.is_loading,
      };
    case "NGANH_LOAD_SUCCESS":
      return {
        ...state,
        status: eReducerStatusBase.is_completed,
        nganhs: [...action.payload],
      };
    case "NGANH_LOAD_ERRR":
      return {
        ...state,
        status: eReducerStatusBase.is_completed,
      };
    case "NGANH_SHOW_EDIT_MODAL":
      return {
        ...state,
        isShowEditModal: true,
        nganhEditing: action.payload,
      };
    case "NGANH_CLOSE_EDIT_MODAL":
      return {
        ...state,
        isShowEditModal: false,
      };
    case "NGANH_SAVE_START":
      return {
        ...state,
        status: eReducerStatusBase.is_saving,
      };
    case "NGANH_SAVE_SUCCESS":
      return {
        ...state,
        status: eReducerStatusBase.is_need_reload,
        isShowEditModal: false,
      };
    case "NGANH_SAVE_ERRR":
      return {
        ...state,
        status: eReducerStatusBase.is_completed,
      };
    case "NGANH_DELETE_START":
      return {
        ...state,
        status: eReducerStatusBase.is_deleting,
      };
    case "NGANH_DELETE_SUCCESS":
      return {
        ...state,
        status: eReducerStatusBase.is_need_reload,
      };
    case "NGANH_DELETE_ERRR":
      return {
        ...state,
        status: eReducerStatusBase.is_completed,
      };
    default:
      return state;
  }
};
